import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useContactsStore } from '../../../modules/contacts/stores/use-contacts.store';
import { IconButton } from '../../../shared/ui/IconButton/IconButton';
import { TextButton } from '../../../shared/ui/TextButton/TextButton';
import Contacts from '../../contacts/Contacts';
import { contactsMock } from '../../contacts/contacts.mock';

type SelectContactsProps = {
  open: boolean;
  onClose: () => void;
};
const SelectContacts = ({ open, onClose }: SelectContactsProps) => {
  const { t } = useTranslation();
  const setContacts = useContactsStore((state) => state.setContacts);

  useEffect(() => {
    setContacts(contactsMock);

    return () => {
      setContacts([]);
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: 'md:w-3/4 lg:w-2/3 xl:w-3/5 min-w-[900px] min-h-[50vh]',
      }}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      scroll="body"
      sx={{
        '& .MuiPaper-root': {
          backgroundImage: 'none',
          margin: 0,
          padding: 0,
          maxWidth: '600px !important',
        },
      }}
    >
      <IconButton
        classes="absolute right-1 top-1"
        icon={['fas', 'times']}
        onClick={onClose}
      />
      <DialogTitle
        sx={{
          padding: '1.5rem',
          paddingTop: '2rem',
        }}
        className="flex font-semibold items-center justify-between"
      >
        <div className="font-semibold text-2xl">Kontakt auswählen</div>
      </DialogTitle>
      <div>
        <Contacts hideAction showOnlySearch />
      </div>
      <DialogContent className="border-b-0" sx={{ padding: '1.5rem' }}>
        <div className="flex justify-end mt-4">
          <TextButton
            classes="mr-2"
            preset="underline"
            textTransform="none"
            onClick={onClose}
          >
            {t('app.cancel')}
          </TextButton>
          <TextButton preset="primary" onClick={() => {}} disabled>
            {t('app.save')}
          </TextButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectContacts;
